import React from 'react';
export default class ClickOutsideListner extends React.Component {
  constructor(props) {
    super(props);
    this.domRef = React.createRef();
    this.listener = this.listener.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.listener, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.listener, true);
  }

  isClickedOutside(e) {
    // e.stopPropagation();
    // If the event target doesn't match bail - analysis view - save and filter panel fix
    // if(e.target.matches('button') || e.target.matches('svg') || e.target.matches('rect') || e.target.matches('polyline') || e.target.matches('span')) return false;
    // console.log(e.target);
    // console.log(this.domRef.current);
    // console.log(this.domRef.current.contains(e.target));

    if (this.domRef.current && !this.domRef.current.contains(e.target)) {
      return true;
    }

    return false;
  }

  listener(e) {
    if (this.isClickedOutside(e)) {
      this.props.onOutsideClick(e);
    }
  }

  render() {
    return (
      <div ref={this.domRef}>
        {this.props.children}
      </div>
    );
  }
}